/*
 * @Author: your name
 * @Date: 2021-09-19 17:04:05
 * @LastEditTime: 2021-12-01 11:44:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\components\index.js
 */
import Vue from 'vue'

Vue.component('bounty-header', () => import('./bountyHeader/index.vue'))
Vue.component('bounty-footer', () => import('./bountyFooter/index.vue'))
Vue.component('bounty-back', () => import('./bountyBack/index.vue'))
Vue.component('bounty-title', () => import('./bountyTitle/index.vue'))
Vue.component('bounty-task', () => import('./bountyTask/index.vue'))
Vue.component('bounty-project-task', () => import('./bountyProjectTask/index.vue'))
Vue.component('bounty-project-detail', () => import('./bountyProjectDetail/index.vue'))
Vue.component('bounty-tip', () => import('./bountyTip/index.vue'))
Vue.component('bounty-task-detail', () => import('./bountyTaskDetail/index.vue'))
Vue.component('bounty-schema-tip', () => import('./bountySchemaTip/index.vue'))
Vue.component('bounty-reject-tip', () => import('./bountyRejectTip/index.vue'))
Vue.component('bounty-schema-list', () => import('./bountySchemaList/index.vue'))
Vue.component('bounty-menu', () => import('./bountyMenu/index.vue'))
